import { profile } from '@/data/profile';

const siteUrl = import.meta.env.VITE_SITE_URL ?? profile.websiteUrl;

export function SeoJsonLd() {
  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: profile.fullName,
    url: siteUrl,
    email: profile.email,
    jobTitle: 'Software Engineer',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Ankara',
      addressCountry: 'TR',
    },
    sameAs: [profile.githubUrl],
  };

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: profile.fullName,
    url: siteUrl,
    description:
      'Portfolio of Muhammad Sufyan Malik — software engineer specializing in .NET, web, and mobile development.',
  };

  const profilePage = {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    mainEntity: {
      '@type': 'Person',
      name: profile.fullName,
      url: siteUrl,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(person) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(website) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(profilePage) }}
      />
    </>
  );
}
